import { createSlice } from "@reduxjs/toolkit";

let user = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));

const initialState = {
    loading: false,
    resetLoading: false,
    acceptDocumentsLoading: false,

    loggingIn: false,
    loggedIn: !!user,
    hubspotSessionClearing: false,

    acceptedTos: false,
    acceptedDpa: false,

    user: user,
    hubspotSessionExists: null,

    resetMail: "",
    resetSuccessMessage: null,
    loginErrorMessage: null,
    forgetPasswordModal: false,
    submitted: false,

    updateModal: false,

    errorMessage: null,
    resetErrorMessage: null,
    acceptDocumentsErrorMessage: null,
    successMessage: null,

    // MFA state
    mfaRequired: false,
    mfaResolverExists: false,
    mfaHints: null,
};

const userAuthenticationSlice = createSlice({
    name: "UserAuthentication",
    initialState,
    reducers: {
        addAdditionalUserData(state, action) {
            state.loggedIn = true;
            state.user = action.payload;
        },

        fetchInitialShopifyDataSuccess(state, action) {
            state.loggedIn = true;
            state.user = action.payload;
        },

        reloadUserRequest(state) {
            state.loading = true;
        },
        updateLoggedInUserSuccess(state, action) {
            state.loggedIn = true;
            state.loading = false;
            state.user = action.payload;
        },
        reloadUserFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },
        loginRequest(state, action) {
            state.loggingIn = true;
            state.loggedIn = false;
            state.errorMessage = null;
            state.user = action.payload;
        },
        loginRequestWithSSO(state, action) {
            state.loggingIn = true;
            state.loggedIn = false;
            state.errorMessage = null;
            state.method = action.payload;
        },
         loginClearSSOMethod(state, action) {
            state.method = null;
            state.user = null;
        },
        loginSuccess(state, action) {
            state.loggingIn = false;
            state.loggedIn = true;
            state.user = action.payload;
            state.errorMessage = null;
        },
        loginFailure(state, action) {
            state.loggingIn = false;
            state.loggedIn = false;
            state.errorMessage = action.payload;
            // Clean up MFA state on login failure
            state.mfaRequired = false;
            state.mfaResolverExists = false;
            state.mfaHints = null;
            // if (typeof window !== 'undefined') {
            //     delete window.__mfaResolver;
            // }
        },

        mfaRequired(state, action) {
            state.loggingIn = false;
            state.mfaRequired = true;
            state.mfaResolverExists = action.payload.resolverExists;
            state.mfaHints = action.payload.hints;
            state.errorMessage = null;
        },

        mfaResolved(state) {
            state.mfaRequired = false;
            state.mfaResolverExists = false;
            state.mfaHints = null;
            // Clean up the global resolver
            // if (typeof window !== 'undefined') {
            //     delete window.__mfaResolver;
            // }
        },

        logoutRequest(state) {
            state.loading = true;
            state.loggedIn = false;
            state.user = null;
        },
        logoutSuccess(state) {
            state.loading = false;
            state.loggedIn = false;
            state.user = null;
            state.errorMessage = null;
        },

        setupResetPasswordRequest(state) {
            state.resetLoading = true;
            state.resetErrorMessage = null;
        },
        setupResetPasswordSuccess(state) {
            state.resetLoading = false;
        },
        setupResetPasswordFailure(state, action) {
            state.resetLoading = false;
            state.resetErrorMessage = action.payload;
        },

        passwordResetRequest(state) {
            state.loading = true;
            state.errorMessage = null;
            state.successMessage = null;
        },
        passwordResetSuccess(state) {
            state.loading = false;
            state.successMessage = "Passwort wurde geändert.";
        },
        passwordResetFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },

        sendActivationLinkRequest(state) {
            state.errorMessage = null;
            state.successMessage = null;
        },
        sendActivationLinkSuccess(state) {
            state.successMessage = "Mail wurde versandt!";
        },
        sendActivationLinkFailure(state, action) {
            state.errorMessage = action.payload;
        },

        activateUserAccountRequest(state) {
            state.loading = true;
            state.errorMessage = null;
        },
        activateUserAccountSuccess(state) {
            state.loading = false;
        },
        activateUserAccountFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },

        acceptDocumentsRequest(state) {
            state.acceptDocumentsLoading = true;
            state.acceptDocumentsErrorMessage = null;
        },
        acceptDocumentsSuccess(state, action) {
            state.acceptDocumentsLoading = false;
            state.user = action.payload;
        },
        acceptDocumentsFailure(state, action) {
            state.acceptDocumentsLoading = false;
            state.acceptDocumentsErrorMessage = action.payload;
        },

        getHubspotSessionRequest(state) {
            state.hubspotSessionExists = null;
            state.errorMessage = null;
        },
        getHubspotSessionSuccess(state, action) {
            state.hubspotSessionExists = action.payload;
        },
        getHubspotSessionFailure(state, action) {
            state.hubspotSessionExists = null;
            state.errorMessage = action.payload;
        },

        clearHubspotSessionRequest(state) {
            state.hubspotSessionClearing = true;
            state.errorMessage = null;
        },
        clearHubspotSessionSuccess(state) {
            state.hubspotSessionExists = null;
            state.hubspotSessionClearing = false;
        },
        clearHubspotSessionFailure(state, action) {
            state.hubspotSessionClearing = false;
            state.errorMessage = action.payload;
        },

        setResetMail(state, action) {
            state.resetMail = action.payload;
        },

        setResetSuccessMessage(state, action) {
            state.resetSuccessMessage = action.payload;
        },
        setLoginErrorMessage(state, action) {
            state.loginErrorMessage = action.payload;
        },
        toggleForgetPasswordModal(state) {
            state.forgetPasswordModal = !state.forgetPasswordModal;
        },
        toggleSubmitted(state) {
            state.submitted = !state.submitted;
        },

        clearResetSuccessMessage(state) {
            state.loading = false;
            state.updateModal = false;
            state.successMessage = null;
            state.errorMessage = null;
        },

        toggleTos(state) {
            state.acceptedTos = !state.acceptedTos;
        },

        toggleDpa(state) {
            state.acceptedDpa = !state.acceptedDpa;
        },
        clearErrorMessage(state) {
            state.errorMessage = null;
        },
    },
});

export default userAuthenticationSlice;
